module.exports = __webpack_public_path__ + "img/qiangji.97c8d743.png";